// Load all the controllers within this directory and all subdirectories.
// Controller files must be named *_controller.js.

import { Application } from 'stimulus'
import { Turbo } from '@hotwired/turbo-rails'
import { definitionsFromContext } from 'stimulus/webpack-helpers'

// Public and authenticated layouts load different Bootstrap generations.
// Full-page navigation keeps their assets isolated while Turbo Streams remain available.
Turbo.session.drive = false

window.Stimulus = Application.start()
const context = require.context('controllers', true, /_controller\.js$/)

Stimulus.load(definitionsFromContext(context))
